var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtDashboardChecklist = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#744C29",
    d: "M18 11.186h34V62H18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.198 13.783h29.601v45.382H20.198z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.468 10.087h-3.753v-1.92c0-.645-.494-1.167-1.1-1.167h-3.227c-.61 0-1.1.524-1.1 1.167v1.92h-3.754c-.607 0-1.1.522-1.1 1.167v2.605c0 .644.493 1.167 1.1 1.167h12.938c.61 0 1.1-.525 1.1-1.167v-2.605c0-.645-.493-1.167-1.1-1.167h-.004zm-6.47.279c-.592 0-1.07-.51-1.07-1.135 0-.626.478-1.136 1.07-1.136.592 0 1.07.508 1.07 1.136 0 .627-.48 1.135-1.07 1.135zM28.232 20.278h19.335V21.8H28.232z",
    fill: "#929597"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 21.762h19.335v1.522H28.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 23.248h19.335v1.522H28.232zM26.715 20.045v4.095h-3.792v-4.095h3.792m.67-.672h-5.13v5.44h5.13v-5.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929597",
    d: "M28.232 27.982h19.335v1.522H28.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 29.466h19.335v1.522H28.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 30.952h19.335v1.522H28.232zM26.715 27.75v4.097h-3.792v-4.098h3.792m.67-.672h-5.13v5.44h5.13v-5.44z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#929597",
    d: "M28.232 35.686h19.335v1.522H28.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 37.172h19.335v1.522H28.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 38.66h19.335v1.521H28.232zM26.715 35.454v4.097h-3.792v-4.097h3.792m.67-.673h-5.13v5.44h5.13v-5.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#929597",
    d: "M28.232 43.393h19.335v1.522H28.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 44.877h19.335v1.522H28.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 46.363h19.335v1.522H28.232zM26.715 43.16v4.097h-3.792V43.16h3.792m.67-.672h-5.13v5.44h5.13v-5.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#929597",
    d: "M28.232 51.097h19.335v1.522H28.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 52.583h19.335v1.522H28.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M28.232 54.069h19.335v1.522H28.232zM26.715 50.866v4.098h-3.792v-4.098h3.792m.67-.672h-5.13v5.44h5.13v-5.44z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.998 10.366c-.592 0-1.07-.51-1.07-1.135 0-.626.478-1.136 1.07-1.136V7.002h-1.615c-.609 0-1.1.524-1.1 1.167v1.92H28.53c-.607 0-1.1.522-1.1 1.167v2.605c0 .645.493 1.167 1.1 1.167h6.468v-4.662z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E20707"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.675 24.022s3.48-3.62 3.83-5.31c-1.263.849-4.36 3.853-4.36 3.853l.53 1.457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 22.567s-1.446-1.545-2.668-2.101c-.283.518 2.278 3.556 2.278 3.556l.39-1.457v.002z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E20707"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.675 47.005s3.48-3.62 3.83-5.309c-1.263.848-4.36 3.852-4.36 3.852l.53 1.457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 45.55s-1.446-1.545-2.668-2.101c-.283.518 2.278 3.556 2.278 3.556l.39-1.457v.002z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E20707"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.675 54.666s3.48-3.62 3.83-5.309c-1.263.848-4.36 3.852-4.36 3.852l.53 1.457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 53.211s-1.446-1.545-2.668-2.101c-.283.518 2.278 3.556 2.278 3.556l.39-1.457v.002z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E20707"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.675 31.502s3.48-3.617 3.83-5.307c-1.263.848-4.36 3.852-4.36 3.852l.53 1.455z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 30.045s-1.446-1.545-2.668-2.101c-.283.52 2.278 3.558 2.278 3.558l.39-1.455v-.002z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E20707"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.675 39.107s3.48-3.618 3.83-5.307c-1.263.848-4.36 3.852-4.36 3.852l.53 1.455z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 37.652s-1.446-1.545-2.668-2.101c-.283.518 2.278 3.558 2.278 3.558l.39-1.455v-.002z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtDashboardChecklist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-dashboard-checklist.56d29f41204be91788bb5fe9523aa805.svg";